var FieldEntryMessageRMQ = [
  { name: "EntryName", type: "str" },
  { name: "RiderName", type: "str" },
  { name: "EarlyScratch", type: "bool" },
  { name: "FinishPos", type: "str" },
  { name: "Weight", type: "int" },
  { name: "IsPTF", type: "bool" },
  { name: "TrainerName", type: "str" },
  { name: "OwnerName", type: "str" },
  { name: "Breeders", type: "str" },
  { name: "Pedigrees", type: "str" },
];

export default FieldEntryMessageRMQ;
